import { lazy } from 'react';
import RankingPage from '../pages/Ranking';
import { AuthenticatedLayout } from '../../../core/components/templates/AuthenticatedLayout';
import StudentAreaLayout from '../../../core/templates/studentArea';
import LogoTemplate from '../../../core/templates/logo';

const SimuladaoPage = lazy(() => import('../pages/Simuladao'));
const SubscriptionPage = lazy(() => import('../pages/Subscription'));
const SubscriptionCompletedPage = lazy(
  () => import('../pages/SubscriptionCompleted')
);
const SISUInfosPage = lazy(() => import('../pages/SISUInfos'));
const InstructionsPage = lazy(() => import('../pages/Instructions'));
const GatePage = lazy(() => import('../pages/Gate'));
const FeedBackPage = lazy(() => import('../pages/FeedBack'));
const AnswersPage = lazy(() => import('../pages/AnswersPage'));
const ReadEssayPage = lazy(() => import('../pages/ReadEssay'));
const EssayThemePage = lazy(() => import('../pages/EssayTheme'));
const EssayFeedbackPage = lazy(() => import('../pages/EssayFeedback'));
const PriorizationPage = lazy(() => import('../pages/Priorization'));
const QuestionDetailsPage = lazy(() => import('../pages/QuestionDetails'));
const FreeSimuladaoLoginPage = lazy(
  () => import('../pages/SimuladaoLoginPage')
);
const AuthCodeLoginPage = lazy(() => import('../pages/AuthCodeLoginPage'));
const CodeValidationPage = lazy(() => import('../pages/CodeValidationPage'));
const StudentSimulationsListPage = lazy(
  () => import('../pages/StudentSimulationsListPage')
);

export const SimuladaoRoutes = [
  {
    path: '/simuladao',
    element: <SimuladaoPage />,
  },
  {
    path: '/simuladao/inscricao',
    element: (
      <AuthenticatedLayout>
        <LogoTemplate>
          <SubscriptionPage />
        </LogoTemplate>
      </AuthenticatedLayout>
    ),
  },
  {
    path: '/simuladao/inscricao/concluida',
    element: (
      <AuthenticatedLayout>
        <SubscriptionCompletedPage />
      </AuthenticatedLayout>
    ),
  },
  {
    path: '/simuladao/sisu',
    element: <SISUInfosPage />,
  },
  {
    path: '/simuladao/instrucoes',
    element: <InstructionsPage />,
  },
  {
    path: '/simuladao/portao',
    element: <GatePage />,
  },
  {
    path: '/simuladao/gabarito/:slug',
    element: <FeedBackPage />,
  },
  {
    path: '/simuladao/gabarito/redacao/aguardando',
    element: <ReadEssayPage />,
  },
  {
    path: '/simuladao/gabarito/redacao/tema',
    element: <EssayThemePage />,
  },
  {
    path: '/simuladao/gabarito/redacao/correcao',
    element: <EssayFeedbackPage />,
  },
  {
    path: '/simuladao/gabarito/:slug/redacao/tema',
    element: <EssayThemePage />,
  },
  {
    path: '/simuladao/gabarito/:slug/redacao/correcao',
    element: <EssayFeedbackPage />,
  },
  {
    path: '/simuladao/gabarito/:slug/respostas/:daySlug',
    element: <AnswersPage />,
  },
  {
    path: '/simuladao/gabarito/:slug/priorizacao',
    element: <PriorizationPage />,
  },
  {
    path: '/simuladao/gabarito/:slug/priorizacao/questao/:questionUuid/:questionOrder',
    element: <QuestionDetailsPage />,
  },
  {
    path: '/simuladao/ranking/:daySlug',
    element: <RankingPage />,
  },
  {
    path: '/simuladao/login',
    element: <FreeSimuladaoLoginPage />,
  },
];

// Rotas da área logada - separadas para não passar pelo SimuladaoTemplate
export const SimuladaoAreaLogadaRoutes = [
  {
    path: '/simuladao/area-logada/login',
    element: <AuthCodeLoginPage />,
  },
  {
    path: '/simuladao/area-logada/validar-codigo',
    element: <CodeValidationPage />,
  },
  {
    path: '/simuladao/area-logada',
    element: (
      <StudentAreaLayout>
        <StudentSimulationsListPage />
      </StudentAreaLayout>
    ),
  },
  {
    path: '/simuladao/area-logada/gabarito/:slug',
    element: (
      <StudentAreaLayout>
        <FeedBackPage isLoggedIn={true}/>
      </StudentAreaLayout>
    ),
  },
  {
    path: '/simuladao/area-logada/ranking/:daySlug',
    element: (
      <StudentAreaLayout>
        <RankingPage isLoggedIn={true}/>
      </StudentAreaLayout>
    ),
  },
  {
    path: '/simuladao/area-logada/gabarito/:slug/respostas/:daySlug',
    element: (
      <StudentAreaLayout>
        <AnswersPage isLoggedIn={true}/>
      </StudentAreaLayout>
    ),
  },
  {
    path: '/simuladao/area-logada/gabarito/:slug/redacao/tema',
    element: (
      <StudentAreaLayout>
        <EssayThemePage isLoggedIn={true}/>
      </StudentAreaLayout>
    ),
  },
  {
    path: '/simuladao/area-logada/gabarito/:slug/redacao/correcao',
    element: (
      <StudentAreaLayout>
        <EssayFeedbackPage isLoggedIn={true}/>
      </StudentAreaLayout>
    ),
  },
  {
    path: '/simuladao/area-logada/gabarito/:slug/priorizacao',
    element: (
      <StudentAreaLayout>
        <PriorizationPage isLoggedIn={true}/>
      </StudentAreaLayout>
    ),
  },
  {
    path: '/simuladao/area-logada/gabarito/:slug/priorizacao/questao/:questionUuid/:questionOrder',
    element: (
      <StudentAreaLayout>
        <QuestionDetailsPage isLoggedIn={true}/>
      </StudentAreaLayout>
    ),
  },
];
